import React, {Fragment} from 'react';
import {Breadcrumb, Button, ScrollTopBtn, SecSubTitle, SecTitle, Seo, TitleWrap} from '../components';
import {
    AboutFive,
    AboutFour, AboutOne, AboutSeven, AboutSix,
    AboutThree, BrandTwo,
    ContactTwo,
    FeatureTwo,
    FooterOne,
    HeaderOneCopy,
    ProcessTwo, TestimonialTwo
} from '../containers';
import productsData from '../data/products.json';
import EVOData from "../data/EVO.json";
import AboutEight from "../containers/Abouts/AboutEight";
import AboutEightWithSideTabs from "../containers/Abouts/AboutEightWithSideTabs";
import AboutTwo from "../containers/Abouts/AboutTwo";
import AboutSevenTextImage from "../containers/Abouts/AboutSevenTextImage";
import ServiceTwoEInvoice from "../containers/Services/ServiceTwoEInvoice";
import AboutFourEInvoice from "../containers/Abouts/AboutFourEInvoice";
import FaqTwo from "../containers/Faqs/FaqTwo";
import ServiceOneEInvoice from "../containers/Services/ServiceOneEInvoice";


const aboutFourData = {
    title: 'How It Works',
    images: [
        "/images/e-invoice/e-invoice-4.webp",
        "/images/e-invoice/e-invoice-3.jpg",
    ],
    points: [
        {
            title: "Invoice Creation",
            text: "Automatically generated from your ERP or POS system.",
        },
        {
            title: "Validation Engine",
            text: "Checks invoice format, tax rules, and required fields.",
        },
        {
            title: "Submission to Authority",
            text: "Invoices are digitally signed and submitted to ZATCA/FTA.",
        },
        {
            title: "Acknowledgment Received",
            text: "Confirmation is sent back and stored securely.",
        },
        {
            title: "Archiving & Reporting",
            text: "All documents are archived and ready for audit.",
        },
    ]


}

const faq = {
    title: "Why Choose Us?",
    subtitle: "Efficiency, Accuracy, Compliance tailored to your trade operations",
    imageTwo:"images/e-invoice/e-invoice-2.jpg",
    points: [
        {
            id: 0,
            title: "Deep ERP Integration Expertise",
            text: "Especially SAP Business One"
        },
        {
            id: 1,
            title: "Localized for KSA & UAE",
            text: "Built with regional tax authority requirements"
        },
        {
            id: 2,
            title: "Future-Ready Platform",
            text: "Adapts to new regulations and countries"
        },
        {
            id: 3,
            title: "White-Glove Support",
            text: "From setup to go-live and beyond"
        },
        {
            id: 4,
            title: "Scalable & Secure",
            text: "Designed to support SMEs and large enterprises alike"
        },
    ]
};


const keyFeatures = [
    {
        "id": "1",
        "title": "Fully Compliant",
        "text": " Built for current and future regulations across GCC countries"
    },
    {
        "id": "2",
        "title": "Real-time Invoice Generation",
        "text": "Instantly create and send digital invoices"
    },
    {
        "id": "3",
        "title": "ZATCA & FTA Integration",
        "text": "Seamlessly submit invoices and receive validations"
    },
    {
        "id": "4",
        "title": "QR Code & XML Support",
        "text": " Generate structured data formats as required by law"
    },
    {
        "id": "5",
        "title": "ERP Integration",
        "text": " Works smoothly with SAP B1, Oracle, Dynamics, and more"
    },
    {
        "id": "6",
        "title": "Digital Signature Support",
        "text": " Sign invoices with secure, tamper-proof certificates"
    },
    {
        "id": "7",
        "title": "Secure & Scalable",
        "text": "Cloud or on-premise hosting options with enterprise-grade security"
    },
    {
        "id": "8",
        "title": "Audit & Archiving",
        "text": "Keep an accessible history of all submitted invoices"
    },
]

const EInvoice = () => (
    <Fragment>
        <Seo title="E-Invoicing"/>
        <HeaderOneCopy/>
        <Breadcrumb pageName="E-Invoicing"
                    pageSubTitle={"E-Invoicing Made Simple & Compliant"}
                    pageDesc={"Powerful, scalable solutions for digital invoicing across regions."}
                    bgImage="images/bg/bg-e-invoice.png"
                    button={<Button path={'/e-invoicing-risk-assessment'} className="style2">REQUEST E-Invoicing Risk Assessment<i className="far fa-arrow-right"/></Button>}
        />


        {/*<div className="container space-extra-bottom">
            <TitleWrap className="text-center space-top ">
                <SecTitle className="text-capitalize h1">E-Invoicing Made Simple & Compliant</SecTitle>
                <SecSubTitle> Powerful, scalable solutions for digital invoicing across regions</SecSubTitle>
            </TitleWrap>

            <div className={'w-100p d-flex space-bottom align-items-center justify-content-center'}>
                <div className={'images-ss-row'}>
                    <img src={'images/e-Invoice/e-invoice-1.jpeg'} alt="tabthumb"
                         style={{objectFit: 'cover', width: '60%', zIndex: 1}}/>
                </div>
            </div>

            <p className="author-degi  text-center"> Transform the way your business handles invoicing. Our E-Invoicing
                platform ensures full compliance, improves efficiency, and seamlessly integrates with your existing
                systems—setting you up for success in a digital economy.</p>

        </div>*/}

        <AboutSevenTextImage/>


        <ServiceTwoEInvoice/>


        <ServiceOneEInvoice
            data={keyFeatures}
        />

        <FaqTwo
            data={faq} isSubtitled={false}
            className={"why-choose-us space-bottom mb-5"}/>



        <AboutFourEInvoice data={aboutFourData}/>

        <FooterOne/>

        <ScrollTopBtn/>
    </Fragment>
);

export default EInvoice;